import box3 from '~/assets/icons/box_3.svg';
import bussiness from '~/assets/icons/bussiness.svg';
import report from '~/assets/icons/report.svg';

export enum AppMyBusinessPages {
	Main = 'main',
	Shop = 'shop',
	Reports = 'reports',
}

export const appMyBusinessMenuItems = {
	[AppMyBusinessPages.Main]: {
		name: 'Главная',
		icon: bussiness,
	},
	[AppMyBusinessPages.Shop]: {
		name: 'Мои товары',
		icon: box3,
	},
	[AppMyBusinessPages.Reports]: {
		name: 'Отчёты',
		icon: report,
	},
};
